import { InjectionToken } from '@angular/core';

export const MS_CLARITY_PROJECT_ID = new InjectionToken<string | undefined>('ms-clarity-project-id');
